import React from 'react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './tailwindInput.css'
import App from './App.jsx'

// Import test helpers in development
if (process.env.NODE_ENV !== 'production') {
  import('./utils/testHelpers.js');
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
